import { createContext, useContext } from 'react';

const ColorContext = createContext('');

export function useColor() {
  const color = useContext(ColorContext);

  return color;
}

export default ColorContext;
